import Sprite from "app/components/sprite";
import signature from "app/images/about-us_signature.png";
import { Trans } from "react-i18next";
import { useState } from "react";

const Quote = () => (
  <p
    className="my-auto mb-10 w-full max-w-[463px] text-center text-[31px] 
    font-extrabold leading-[39px] ltr:mr-0 rtl:ml-0 lg:my-auto lg:text-[45px] 
    lg:leading-[55px] ltr:lg:mr-16 rtl:lg:ml-16 ltr:xl:mr-28 rtl:xl:ml-28"
  >
    <Sprite
      name="about-us-endquote"
      className="mx-auto mb-7 h-[40px] lg:h-[50px]"
    />
    <Trans>We are witnessing </Trans>
    <span className="text-cyan-dark">
      <Trans>a disruptive</Trans>
    </span>
    <Trans> way</Trans>
    <br />
    <Trans>of doing business called </Trans>
    <span className="text-green-dark">
      <Trans>cCommerce.</Trans>
    </span>
    <Sprite
      name="about-us-quote"
      className="mx-auto mt-7 h-[40px] lg:h-[50px]"
    />
  </p>
);

const Message = () => (
  <div
    className="w-full max-w-[393px] font-medium ltr:ml-0 rtl:mr-0 ltr:lg:ml-16 
    rtl:lg:mr-16 ltr:xl:ml-28 rtl:xl:mr-28"
  >
    <p className="text-base leading-6 lg:text-sm rtl:lg:text-base">
      <Trans>
        Messaging and social apps are converging with commerce in new and
        innovative ways. Zbooni was born to seamlessly bring the two worlds
        together and allow businesses to capture this opportunity.
      </Trans>
      <br />
      <br />
      <Trans>
        What began as a solution to help small businesses in the UAE expanded
        quickly. We now serve businesses of all shapes and sizes across multiple
        countries. Our vision of empowering businesses, and understanding what
        they really need remains true.
      </Trans>
      <br />
      <br />
      <Trans>
        Thank you for being here, we’re happy to have you. If there is anything
        we can help you with, please don’t hesitate to get in touch.
      </Trans>
    </p>
    <div className="relative flex w-full flex-row justify-between">
      <p className="mt-16 text-base leading-[26px]">
        <Trans>Ramy Assaf,</Trans>
        <br />
        <Trans>Founder & CEO</Trans>
      </p>
      <img
        alt=""
        src={signature}
        className="absolute -bottom-6 w-[174px] ltr:right-0 rtl:left-0"
      />
    </div>
  </div>
);

export const HeroSection = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <section
      className={`
      relative h-screen bg-primary
      pb-20 pt-28 font-montserrat
      text-base text-white sm:h-full lg:pb-32
      lg:pt-40
      ${isCollapsed ? `h-full` : `h-screen`}
    `}
    >
      <div
        className={`
        zbooni-layout relative
        ${isCollapsed ? `h-full` : `h-[600px]`}
        lg:h-full
      `}
      >
        <Sprite
          name="circle-desktop"
          className="absolute right-0 hidden h-[400px] w-[300px] 
          translate-x-[20px] translate-y-[-50px] scale-x-[-1] transform 
          md:right-0 md:block md:h-[400px] md:w-[500px] md:translate-y-[60px] 
          md:scale-x-[1] ltr:md:left-0 ltr:md:translate-x-[-150px] 
          rtl:md:translate-x-[150px] lg:h-[490px] lg:w-[650px] 
          lg:-translate-y-8 ltr:lg:translate-x-[-200px]
          rtl:lg:translate-x-[250px] xl:w-[600px] xl:-translate-y-16"
        />
        <div
          className="relative flex flex-col items-center justify-center
          lg:flex-row"
        >
          <Quote />
          <Message />
        </div>
      </div>
      <div
        className={`
        zbooni-layout absolute bottom-0 z-[1] flex
        w-full bg-primary lg:hidden
        ${isCollapsed ? "hidden" : "block"}
      `}
      >
        <div className="w-[393px] md:mx-auto">
          <button
            className="flex items-center py-10 "
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <Sprite name="read-all" className="h-[10px] w-[10px]" />
            <p className="text-white ltr:ml-3 rtl:mr-3">
              <Trans>Read all</Trans>
            </p>
          </button>
        </div>
      </div>
    </section>
  );
};
